<template>
  <div class="app-main-layout">
    <div class="wrapper">
      <Sidebar v-model="isOpen" />
      <div style="width: 100%; background-color: #eaeaea;">
        <Navbar @click="isOpen = !isOpen" />
        <div class="myContainer w-100">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from '@/components/app/Navbar'
  import Sidebar from '../components/app/Sidebar.vue'

  export default {
    name: 'main-layout',
    data: () => ({
      isOpen: false,
    }),
    mounted() {
    },
    methods: {
    },
    components: {
      Sidebar, Navbar,
    }
  }
</script>

<style>
  .v-tabs {
    width: 100%;
  }
  .v-slide-group__content {
    display: flex;
    justify-content: center;
  }

  .myContainer {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
  }

  .item-row + .item-row .row {
    border-top: 1px solid #eee;
  }
  .item-row:hover {
    background-color: #fafafa;
  }
</style>